import {
  FETCH_PICKUP_ROOM_GROUPS
} from '../actions/search'

const initialState = {}

export default function namespacedReducer(namespace) {
  return (state = initialState, action) => {
    switch(action.type) {
    case `${namespace}: ${FETCH_PICKUP_ROOM_GROUPS}`:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
    }
  }
}
